import script from "./WeekContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__